import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles (theme => ({
  header: {
    backgroundColor: '#2d3748',
    color: '#808d9f',
    borderRadius: 10,
  },
  homeIcon: {
    backgroundColor: 'red',
  },
  socialHeader: {
    display: 'flex',
    marginLeft: 100,
    padding: 10,
  },
  icon: {
    marginRight: -60,
    marginLeft: -60,
  },
  tab: {
    marginRight: -20,
    fontFamily: "'Roboto Slab', serif",
  },
  btn: {
    backgroundColor: '#808d9f',
    border: 0,
    borderRadius: 50,
    padding: '3px 15px',
    marginLeft: 20,
    outline: 'none',
    "&:hover": {
        backgroundColor: "#808d9f"
      }
  },

  btnicon: {
    color: "#808d9f",
    background: "#2d3748",
    borderRadius: 50,
    height: 27,
    width: 27,
    lineHeight: 29,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  text: {
    fontSize: 14, 
    textTransform: "none",      
    textAlign: "center",
    width: "100%",
    marginLeft: 5,
    marginRight: 5,
    color: "#2d3748",
  },
  a: {
    
    color: '#808d9f',
    '&:hover': {
      color: '#bdbdbd',
    },
  },
  contactInfoSocial: {
    marginRight: 10,
    marginTop: 5
  },
}));

export default useStyles;
